export default __webpack_public_path__ + "static/media/ic_timer.75dcf61c.svg";